import { render, staticRenderFns } from "./MessagesSendModal.vue?vue&type=template&id=05423fbf&"
import script from "./MessagesSendModal.vue?vue&type=script&lang=js&"
export * from "./MessagesSendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports